// extracted by mini-css-extract-plugin
export default {"title":"_1MlemE78cj"};
    if(module.hot) {
      // 1625219407020
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  